import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import * as assessmentCrud from '../../../../crud/assessment.crud';
import { notificationUniqueTagsFilterV2 } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields) => {
    const formFields = [
        {
            caption: fields.Subject.label,
            dataField: 'subject',
            required: true,
            dataType: 'string',
            min: 1,
            max: 250
        }
    ];

    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'type',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        });
    }

    if (fields.Description.visible) {
        formFields.push({
            caption: fields.Description.label,
            dataField: 'description',
            required: fields.Description.required,
            dataType: 'long-string',
        });
    }

    if (fields.TaskOrder.visible) {
        formFields.push({
            caption: fields.TaskOrder.label,//this.props.taskOrderNotificationName + ' ID',
            dataField: 'taskorderid',
            required: false,
            dataType: 'integer',
        });
    }

    if (fields.ProjectOrder.visible) {
        formFields.push({
            caption: fields.ProjectOrder.label,//this.props.projectOrderNotificationName + ' ID',
            dataField: 'projectorderid',
            required: false,
            dataType: 'integer',
        });
    }

    if (fields.Amount.visible && fields.EffectContractPrice) {
        formFields.push({
            caption: fields.EffectContractPrice.label,
            dataField: 'effectcontractprice',
            required: fields.EffectContractPrice.required,
            dataType: 'bool'
        });

        formFields.push({
            caption: fields.Amount.label,
            dataField: 'amount',
            required: fields.Amount.required,
            dataType: 'money'
        });
    }

    if (fields.Days.visible && fields.EffectContractCompletion) {
        formFields.push({
            caption: fields.EffectContractCompletion.label,
            dataField: 'effectcontractcompletion',
            required: fields.EffectContractCompletion.required,
            dataType: 'bool'
        });

        formFields.push({
            caption: fields.Days.label,
            dataField: 'days',
            required: fields.Days.required,
            dataType: 'integer'
        });
    }

    return formFields;
}

class AssessmentListPage extends BaseListPage {
    constructor(props) {
        super(props);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.batchFormFields = getBatchFormFields(props.workflowItem.fields);

        this.state = {
            notifications: null,
            tagsFilters: null
        };
    }

    formatCurrency = () => {
        return this.props.contract.currency
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchNotifications();
    }

    fetchNotifications = async () => {
        try {
            const { contractid } = this.props.contract;
            const { data: responseObj } = await assessmentCrud.getRegisterList(
                contractid,
                this.props.workflowItem.config.currentModelType,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed,
                this.props.accessibleWfIds);
            let notifications = CustomFieldHelper.MapDataListCustomFieldsToObjectProperties(responseObj.aggregatelist);
            let tagFilters = notificationUniqueTagsFilterV2(responseObj);
            this.setState({ notifications, tagFilters });//
        } catch (error) {
            console.log(error);
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }

    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.assessmentid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = 'secondary';
        switch (cellInfo.data.status) {
            case 'NOT_COMMUNICATED':
                badgeVariant = 'secondary';
                break;
            case 'COMMUNICATED':
                badgeVariant = 'success';
                break;
            default:
                break;
        }
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        if (rowData.status) {
            return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
        }
        else {
            return "";
        }
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }

        const { fields } = this.props.workflowItem;

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { caption: fields.Subject.label, dataField: 'subject' },
            { resource: "GENERAL.FORMS.FIELD.CREATED_DATE", dataField: "createdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "communicateddate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        ];
        if(this.props.contract.ispackaged || fields.Amount.visible){
            columns.push(
                { caption: fields.Amount.label, dataField: 'amount', dataType: 'currency', currencyCode: this.props.contract.currency },
                { caption: fields.EffectContractPrice.label, dataField: 'effectcontractprice' },

            );
        }
        if(fields.Days.visible){
            columns.push(
                { caption: fields.Days.label, dataField: 'days' },
                { caption: fields.EffectContractCompletion.label, dataField: 'effectcontractcompletion' },
            );
        }
        
        if (fields.TaskOrder.visible) {
            columns.push(
                { caption: fields.TaskOrder.label, dataField: "taskorderreference", isHtml: true }
            );
        }
        if (fields.ProjectOrder.visible) {
            columns.push(
                { caption: fields.ProjectOrder.label, dataField: "projectorderreference", isHtml: true }
            );
        }

        columns.push(
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.CURRENCY", dataField: "currency", visible: false, calculateCellValue: this.formatCurrency },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "projectname", visible: false }
        );

        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tagFilters.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tagFilters.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tagFilters.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tagFilters.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="2"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={assessmentCrud.importAssessments}
                        batchDeleteEndpoint={assessmentCrud.deleteAssessmentDrafts}
                        batchCommunicateEndpoint={assessmentCrud.communicateAssessmentDrafts}
                        onBatchRecordsUpdated={this.fetchNotifications}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="assessmentid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(AssessmentListPage);
